import { Component, ViewEncapsulation, Input, Output, EventEmitter, AfterViewInit, ElementRef, ViewChild, NgZone, HostListener } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { OvsComponent, GeographicalRegion, Country, ApplicationConfiguration, Core, TargetEnvironment, Queryable, ClientVersion, QueryParamService, LabelNames, DisplayLabel, Member } from '../shared/core/ovs.core';

import { GeocoderResult } from '../shared/geo/ovs.geocoding';
import { SearchState, FilterState } from '../models/browser.model';
import { ResortSummary, ResortOutlook, ResortApplicationConfiguration, MarketingOffer, SearchLocale } from '../models/presentation.model';
import { ResortApplicationBase } from '../services/resort-application.service';
import { ResortSummaryClientBase } from '../services/resort-summary.client';
import { ResortComponent } from '../shared/resort.component';
import { Coordinates, CoordinateType } from '../shared/geo/ovs.geocoding';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatSliderChange } from '@angular/material';
import Swiper from 'swiper';
import * as moment from 'moment';
import { DistanceInfo } from './distance-info.model';
import { ApplicationConfigurationClientBase } from '../services/application-configuration.client';
import { CookieService } from '@ngx-toolkit/cookie';
import { UpdateClientService } from '../services/update-client.service';

import { SearchEvents, SearchResultEvents } from '../instrumentation/resort-instrumentation.module';
import { SearchType } from './search-types.model';
import { ResortPageViews } from '../instrumentation/resort-custom-events';
import { SearchProperties, VirtualPageProperties, MemberProperties, DisplayOptionsProperties } from '../instrumentation/tealium/tealium-data-points.model';
import { UserActivityLogger, UserActivityLoggerOptions, UserActivityPublishDataTypes, SearchCriteria, AgentInfo } from '../instrumentation/user-activity-logger.service';
import { ResortListingLabelNames } from './resort-listing-label-names';
import { ModalSearchFilterComponent } from '../shared/modal-search-filter/modal-search-filter.component';

@Component({
    selector: 'resort-listing',
    templateUrl: './resort-listing.component.html',
    styleUrls: ['./resort-listing.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class ResortListingComponent extends ResortComponent {
    private _app: ResortApplicationBase;
    private _resorts: ResortSummaryClientBase;
    @ViewChild("searchTextControl")
    private _searchTextControl: ElementRef;
    private _selectedLatLong: Coordinates = null;
    private _selectedCountry?: number;
    private _selectedState?: number;
    private _autocomplete: google.maps.places.Autocomplete;
    private _zone: NgZone;
    private _formBuilder: FormBuilder;
    private _actualNights: number[] = [];
    private _isCitySearch: boolean = false;
    private _defaultSearchResults: ResortSummary[] = [];
    private _initialSearch: boolean = true;
    private _countryName: string;
    private _stateName: string;
    private _cityName: string;
    public searchState: SearchState = null;
    public resorts: ResortSummary[] = [];
    public allResorts: ResortSummary[] = [];
    public defaultSearchResultsDisplayed: boolean;
    public nearSearchResultsDisplayed: boolean;
    public searchText: string;
    public isSearching: boolean = false;
    public selectedDate: Date = new Date();
    public canSearch: boolean = false;
    public sleepFilter: number = 2;
    public formGroup: FormGroup;
    public minPrice: number;
    public maxPrice: number;
    public selectedPrice: number;
    public canShow: boolean = false;
    public totalResults: number = 0;
    public nights: SearchFilterNight[] = [];
    public selectedNight: SearchFilterNight;
    public selectedSearchLocale: SearchLocale;
    public isFiltering: boolean = false;
    public filteredCount: number = 0;
    public filterClicked: boolean = true;
    public distanceInfo: DistanceInfo = new DistanceInfo();
    public marketingOffers: Array<MarketingOffer>;

    public roundSearchBar: boolean = true;
    public altSearch: boolean = true;
    public mktHeroDisplay: boolean = true;

    public defaultSearchDate: Date;
    private searchCritera: SearchCriteria = new SearchCriteria();
    public filteredModalCount: number = 0;
    public filteredNightsModalFlag: boolean = false;
    public filteredSleepsModalFlag: boolean = false;
    public filteredPriceSliderModalFlag: boolean = false;
    public agentInfo: AgentInfo = new AgentInfo();
    public agentJwt: string;
    public filterString: string;


    // Get Display option label keys and values

    public getLabel(key: string): string {
        const contextKey = ResortListingLabelNames[key];
        return Core.current.getLabel(contextKey);
    }

    public getKey(key: string): string {
        return ResortListingLabelNames[key];
    }

    public get searchDisclaimer(): string {

        let labelObj: DisplayLabel = this.configuration.Labels ? this.configuration.Labels.firstOrDefault(l => l.Name == LabelNames.SearchDisclaimerLabel) : null;

        if (this.defaultSearchResultsDisplayed) {
            labelObj = this.configuration.Labels ? this.configuration.Labels.firstOrDefault(l => l.Name == LabelNames.SearchDisclaimerNoResultsLabel) : null;
        }
        if (labelObj !== null && labelObj.DisplayText !== null && labelObj.DisplayText.trim() !== '') {
            return labelObj.DisplayText;
        } else {
            return undefined;
        }
    }

    @ViewChild('searchFilterResultModal') searchFilterResultModal: ModalSearchFilterComponent;
    constructor(zone: NgZone, app: ResortApplicationBase, private updateClientService: UpdateClientService
        , resorts: ResortSummaryClientBase, formBuilder: FormBuilder, private qryParamService: QueryParamService) {
        super();
        this._app = app;
        this._resorts = resorts;
        this._zone = zone;

        this._formBuilder = formBuilder;
        this.formGroup = this._formBuilder.group({ 'single': [10] });

        this.listenForChange<number>(() => this.sleepFilter, (o, n) => this.filter());
    }

    protected initialize(): void {
        super.initialize();

        window.scroll(0, 0);

        this.marketingOffers = this.application.configuration.MarketingOffers;
        this.roundSearchBar = this.application.configuration.SearchSettings.IsRoundedThemeEnabled;
        this.altSearch = this.application.configuration.SearchSettings.IsFullWidthEnabled;
        this.mktHeroDisplay = this.application.configuration.MarketingHeroSettings.IsDisplayEnabled;
        this.selectedNight = new SearchFilterNight(null, "Any");
        let isDirect: boolean = this.qryParamService.resortListingParams.isDirect;

        if (isDirect == true) {
            this.selectedDate = this.qryParamService.resortListingParams.searchDate;
            this.searchText = this.qryParamService.resortListingParams.searchText;
            let lat: number = this.qryParamService.resortListingParams.latitude;
            let lng: number = this.qryParamService.resortListingParams.longitude;
            let searchId: string = this.qryParamService.resortListingParams.searchId;
            this._selectedLatLong = new Coordinates(lat, lng, CoordinateType.None);
            this.searchCritera.searchText = this.searchText;
            this.searchCritera.selectedDate = this.selectedDate;
            this.searchCritera.latitude = lat;
            this.searchCritera.longitude = lng;
            this.searchCritera.searchId = searchId;

            this.parseCountryState(this.searchText);
            this.search(searchId, SearchType.Direct);
        }
        else {
            let searchState: SearchState = this.application.searchState;
            if (searchState && searchState.StartDate && !String.isNullOrWhiteSpace(searchState.OriginalSearchText)) {
                this.selectedDate = searchState.StartDate;
                this.searchText = searchState.OriginalSearchText;
                this._selectedLatLong = new Coordinates(searchState.LatLong.Latitude, searchState.LatLong.Longitude, CoordinateType.None);
                this.searchCritera.selectedDate = this.selectedDate;
                this.searchCritera.searchText = this.searchText;
                this.searchCritera.latitude = this._selectedLatLong.Latitude;
                this.searchCritera.longitude = this._selectedLatLong.Longitude;
                this.parseCountryState(this.searchText);
                this.search("");
            }
            else {
                // If we got this far, apply the default search.
                let months: number = this.application.configuration.DefaultSearchMonthsAhead ? this.application.configuration.DefaultSearchMonthsAhead : 2;
                var date = new Date();
                var year = date.getFullYear();
                var month = date.getMonth();
                this.selectedDate = moment(new Date(year, month, 1)).add(months, "months").toDate();
                this.searchCritera.selectedDate = this.selectedDate;
                this.search("", SearchType.Default);

            }
        }

        if (!this.configuration.HasLocaleDropDown) {
            let options: google.maps.places.AutocompleteOptions = <google.maps.places.AutocompleteOptions>{};
            this._autocomplete = new google.maps.places.Autocomplete(this._searchTextControl.nativeElement, options);
            this._autocomplete.addListener("place_changed", () => this.onPlaceChanged());
        }
        this.application.configuration.NameId = this.qryParamService.applicationParams.nameId;
        UserActivityLogger.publish(this.application.configuration, UserActivityPublishDataTypes.ApplicationConfiguration);
    }

    public reset(): void {
        this.nights.forEach(n => n.isSelected = false);
        this.selectedPrice = this.maxPrice;
        this.sleepFilter = 2;
        this.filteredModalCount = 0;
        this.filteredNightsModalFlag = false;
        this.filteredSleepsModalFlag = false;
        this.filteredPriceSliderModalFlag = false;
        this.filter();
    }

    public onSearchFilterClick(): void {

        this.searchFilterResultModal.openSearchFilterModal();
    }

    private onPlaceChanged(): void {
        this._selectedState = 0;
        this._selectedCountry = 0;
        this._isCitySearch = false;
        this.distanceInfo.displayDistance = false;
        let place: google.maps.places.PlaceResult = this._autocomplete.getPlace();
        if (!place || !place.geometry || !place.geometry.location)
            return;

        //9595:allow landmarks
        this.setCountryState(place);

        this._isCitySearch = place.address_components.length >= 3;
        this.distanceInfo.displayDistance = this._isCitySearch;
        this.distanceInfo.city = this._searchTextControl.nativeElement.value;

        this._zone.run(() => {
            this.searchText = this._searchTextControl.nativeElement.value;
            this._selectedLatLong = new Coordinates(place.geometry.location.lat(), place.geometry.location.lng(), CoordinateType.None);
            this.searchCritera.searchText = this.searchText;
            this.searchCritera.latitude = this._selectedLatLong.Latitude;
            this.searchCritera.longitude = this._selectedLatLong.Longitude;

            UserActivityLogger.logEvent(SearchEvents.DestinationEntered, { city: this.distanceInfo.city, lat: this._selectedLatLong.Latitude, lng: this._selectedLatLong.Longitude }, UserActivityLoggerOptions.AppInsightsOnly);

            this.search("", SearchType.UserInitiated);
        });
    }

    private parseCountryState(searchText: string) {
        let searchParts = searchText.split(',');
        let countryName: string;
        let stateName: string;
        let length: number = searchParts.length;

        if (searchParts && length > 1) {
            countryName = searchParts[length - 1] ? searchParts[length - 1].trim() : null;
            stateName = searchParts[length - 2] ? searchParts[length - 2].trim() : null;
            if (length >= 2) {
                this._cityName = searchParts[0].trim();
                this.searchCritera.city = this._cityName;
            }
            this._countryName = countryName;
            this._stateName = stateName;
            this.searchCritera.state = stateName;
            this.searchCritera.country = countryName;
        }
        else if (length === 1) {
            countryName = searchParts[0];
        }

        if (searchParts.length > 2) this._isCitySearch = true;

        this.setSelectedCountryAndState(countryName, stateName);
    }

    setCountryState(place: google.maps.places.PlaceResult) {
        let countryName: string;
        let stateName: string;
        let cityName: string;
        var length = place.address_components.length;

        if (place.address_components.length >= 1) {
            place.address_components.forEach(i => {
                if (i.types.contains('locality'))
                    cityName = i.long_name;
                if (i.types.contains('country'))
                    countryName = i.long_name;
                if (i.types.contains('administrative_area_level_1') || i.types.contains('administrative_area_level_2') || i.types.contains('administrative_area_level_3') || i.types.contains('administrative_area_level_4'))
                    stateName = i.long_name;
            });
        }
        this.searchCritera.country = countryName;
        this.searchCritera.state = stateName;
        this.searchCritera.city = cityName;
        this.setSelectedCountryAndState(countryName, stateName);
    }

    private setSelectedCountryAndState(countryName: string, stateName: string) {
        if (countryName === 'United States') {
            countryName = 'USA';
        }
        let countries = (<ResortApplicationConfiguration>this.configuration).Countries;
        let country = countries.find((c: Country) => {
            return c.Name === countryName;
        });
        let state: GeographicalRegion;
        if (country) {
            this._selectedCountry = country ? country.Id : 0;
            if (country && stateName) {
                let states: GeographicalRegion[] = [];
                states = this.application.configuration.Regions.where(s => s.CountryId == country.Id).toArray();

                state = states.find((s: GeographicalRegion) => {
                    return s.Name === stateName || s.Code == stateName;
                });
                this._selectedState = state ? state.Id : 0;
            }
        }
    }

    public searchButtonClicked(): void {
        this.search('', SearchType.UserInitiated);
    }

    public search(searchId: string, searchType: SearchType = SearchType.UserInitiated): void {
        if ((searchType !== SearchType.Default && searchType !== SearchType.Banner) && !(this.isSearching == false && this._selectedLatLong != null))
            return;
        this.updateClientService.EnsureLatestVersion(() => {
            this.performSearch(searchId, searchType);
        });
    }

    handleErr(e) {
        UserActivityLogger.logEvent(SearchEvents.SearchFailure, this.mapAppInsightsCustomEvents(e.message,e.status), UserActivityLoggerOptions.AppInsightsOnly);
    }

    private performSearch(searchId: string, searchType: SearchType = SearchType.UserInitiated): void {
        let nameId: string = this.application.configuration.NameId;
        this.isSearching = true;
        this.defaultSearchResultsDisplayed = false;
        let dateString: string = moment(this.selectedDate).format("MM/DD/YYYY");
        let country = this._selectedCountry ? this._selectedCountry : 0;
        let state = this._selectedState ? this._selectedState : 0;
        let lat: number = this._selectedLatLong && (this.application.configuration.HasLocaleDropDown || this._isCitySearch || country == 0) ? this._selectedLatLong.Latitude : 0;
        let lng: number = this._selectedLatLong && (this.application.configuration.HasLocaleDropDown || this._isCitySearch || country == 0) ? this._selectedLatLong.Longitude : 0;
        this.searchCritera.searchFilter = this.filterString;
        this.searchCritera.selectedDate = this.selectedDate;
        UserActivityLogger.publish(this.searchCritera, UserActivityPublishDataTypes.SearchCriteria);
        UserActivityLogger.publish(this.configuration.Member, UserActivityPublishDataTypes.Member);

        switch (searchType) {

            case SearchType.Default:
                UserActivityLogger.logEvent(SearchEvents.DefaultSearchInitiated, { selectedDate: dateString }, UserActivityLoggerOptions.AppInsightsOnly);
                break;

            case SearchType.Direct:
                UserActivityLogger.logEvent(SearchEvents.DirectSearchInitiated, { selectedDate: dateString, destination: this.searchText, lat: lat, lng: lng, searchId: searchId }, UserActivityLoggerOptions.AppInsightsOnly);
                break;

            case SearchType.Banner:
                UserActivityLogger.logEvent(SearchEvents.BannerSearchClicked, { searchId: searchId }, UserActivityLoggerOptions.AppInsightsOnly);
                break;

            case SearchType.UserInitiated:

                UserActivityLogger.logEvent(SearchEvents.SearchButtonClicked, { selectedDate: dateString, destination: this._searchTextControl.nativeElement.value, lat: lat, lng: lng }, UserActivityLoggerOptions.AppInsightsOnly);
                break;
        }
        try {
            var self = this;
            this._resorts.Get(nameId, dateString, lat, lng, country, state, searchId, v => this.onSearchCompleted(v),self.handleErr.bind(this));
        } catch (ex) {
            UserActivityLogger.logEvent(SearchEvents.SearchFailure, this.mapAppInsightsCustomEvents(ex.message, ex.code), UserActivityLoggerOptions.AppInsightsOnly);
        }
    }

    private mapAppInsightsCustomEvents(errorMessage, httpErrorCode) {
        const mapData = new Map();
        mapData.set("memberid", this.application.configuration.Member.Id);
        mapData.set("ovcpartnerid", this.application.configuration.Partner.Id);
        mapData.set("ovcpartner", this.application.configuration.Partner.LongName);
        mapData.set("memberclass", this.application.configuration.MemberClass);
        mapData.set("errormessage", errorMessage ? errorMessage : "Search error unknown");
        mapData.set("httperrorcode", httpErrorCode);
        mapData.set("product", "Resort");
        mapData.set("origination", "ICE");
        let jsonObject = {};
        mapData.forEach((value, key) => {
            jsonObject[key] = value;
        });
        return jsonObject;
    }


    public searchById(event: any): void {
        this.updateClientService.EnsureLatestVersion(() => {
            this.search(event, SearchType.Banner);
        });
    }

    public showMore(): void {
        let displayedCount: number = this.resorts.length + 10;
        if (displayedCount > this.filteredCount)
            displayedCount = this.filteredCount;

        this.resorts = this.applyFilter(this.allResorts).take(displayedCount).toArray();
    }

    @HostListener('window:scroll', ['$event']) onScrollEvent($event) {
        if ($event.currentTarget && $event.target && $event.target.scrollingElement)
            var scrollPercent = Math.round(100 * $event.currentTarget.scrollY / $event.target.scrollingElement.scrollHeight);
        if (scrollPercent > 70) this.showMore();
    }

    private onSearchCompleted(resorts: ResortSummary[]): void {
        this.isSearching = false;

        let currentDate: Date = new Date();
        resorts.forEach(i => {
            let durations: number[] = i.resortDurationList.select(d => d.duration).orderBy(d => d).toArray();
            i.nightsDisplayText = durations.join(", ") + (durations.contains(7) ? "+" : "");
            i.selectedResortOutlook = i.resortOutlookList.firstOrDefault(o => o.date.getMonth() == currentDate.getMonth() && o.date.getFullYear() == currentDate.getFullYear());
        });

        if (resorts.length === 0 && !this._initialSearch) {
            let errorMessage = `Zero results found for the destination - ${this.searchCritera.searchText} for ${this.selectedDate.toLocaleString('default', { month: 'long' })}, ${this.selectedDate.getFullYear()}`;
            let httpErrorCode = "";
            UserActivityLogger.logEvent(SearchEvents.SearchFailure, this.mapAppInsightsCustomEvents(errorMessage, httpErrorCode), UserActivityLoggerOptions.AppInsightsOnly);


            resorts = this._defaultSearchResults;
            if (!resorts && resorts.length < 1) {
                errorMessage = "Default search failed.";
                UserActivityLogger.logEvent(SearchEvents.SearchFailure, this.mapAppInsightsCustomEvents(errorMessage, httpErrorCode), UserActivityLoggerOptions.AppInsightsOnly);
            }
           

            this.defaultSearchResultsDisplayed = true;

        }

        this.allResorts = resorts;

        this.totalResults = this.allResorts.length;
        this.canShow = this.totalResults >= 1;

        if (this.canShow) {
            this.minPrice = this.allResorts.min(i => i.startingFrom);
            this.maxPrice = this.allResorts.max(i => i.startingFrom);
            this.selectedPrice = this.maxPrice;

            let nights: SearchFilterNight[] = [];

            this.allResorts.forEach(r => {
                // TODO:  Remove this line of code when the service is fixed.
                r.resortOccupancyList.forEach(o => o.maxOccupancy = o.adultOccupancy + o.childOccupancy);

                r.resortDurationList.forEach(d => {
                    let cappedDuration: number = d.duration > 7 ? 7 : d.duration;
                    if (!nights.any(i => i.duration == cappedDuration)) {
                        this._actualNights.add(d.duration);
                        nights.add(new SearchFilterNight(cappedDuration, cappedDuration == 7 ? "7+" : cappedDuration.toString()));
                    }
                });

            });

            if (this._initialSearch) {
                this._defaultSearchResults = this.allResorts;
                this.defaultSearchDate = this.selectedDate;
                this._initialSearch = false;
            }

            this.initializeNights(nights);

            this.resorts = this.applyFilter(resorts).take(10).toArray();
            this.searchState = new SearchState(this._selectedLatLong, this.allResorts, this.selectedDate, this.searchText);
            this.application.searchState = this.searchState;
        }
        else {
            this.resorts = [];
            this.allResorts = [];
            this.totalResults = 0;
            this.nights = [];
            this._actualNights = [];

        }

        this.filter();

        if (this.application.configuration.IsAgent) {
            this.agentInfo.agent_first_name = this.application.configuration.AgentFullName;
            this.agentInfo.agent_last_name = this.application.configuration.AgentFullName;
            this.agentInfo.agent_email = this.application.configuration.AgentEmail;
            this.agentInfo.agent_assist_date = this.application.configuration.AgentAssistDate;
            this.agentInfo.agent_phone = this.application.configuration.AgentPhoneNo;
            UserActivityLogger.publish(this.agentInfo, UserActivityPublishDataTypes.AgentInfo);
        }

        UserActivityLogger.publish(resorts, UserActivityPublishDataTypes.SearchResults);
        UserActivityLogger.logEvent(SearchEvents.SearchResultsReceived, resorts, UserActivityLoggerOptions.AppInsightsOnly);
        UserActivityLogger.logPageView(ResortPageViews.SearchResults, UserActivityLoggerOptions.Both);
    }

    private initializeNights(nights: SearchFilterNight[]): void {

        if (this.application.configuration.SearchSettings.IsFullWidthEnabled) {
            this.nights = [];
            this.nights.addRange(nights.orderBy(n => n.duration).toArray());
            this.selectedNight = this.nights.where(n => n.duration < 0).firstOrDefault();
        }
        else {
            this.nights = nights.orderBy(n => n.duration).toArray();
        }
    }

    public changeSelectedPrice(newPrice: MatSliderChange): void {
        this.selectedPrice = Math.ceil(newPrice.value);
        this.filter();
    }

    public selectedDateChanged(date) {
        if (date !== this.selectedDate) {
            this.selectedDate = date;
            this.search("");
        }
    }

    public selectedNightChanged(night) {

        this.nights.forEach(n => {
            n.isSelected = (n.duration == night.duration);
        });

        this.filter();
    }

    public selectedSearchLocaleChanged(locale: SearchLocale) {
        this._selectedCountry = locale && locale.CountryId;
        this._selectedState = locale && locale.StateId;
        this._selectedLatLong = locale && new Coordinates(Number.parseFloat(locale.Latitude), Number.parseFloat(locale.Longitude), CoordinateType.None);

        this.search("");
    }

    public isCenter(): boolean {
        return this.application.configuration.ShowPricing === false;
    }

    public filter(): void {
        if (!this.allResorts)
            return;

        let filteredResults: ResortSummary[] = this.applyFilter(this.allResorts).toArray();
        this.filteredCount = filteredResults.length;

        this.resorts = filteredResults.take(10).toArray();
    }

    private applyFilter(resorts: ResortSummary[]): IQueryable<ResortSummary> {
        let nights: number[] = this.nights.where(n => n.isSelected && n.duration > 0).select(n => n.duration).toArray();
        this.filterString = '';

        if (nights && nights.length > 0 && !this.filteredNightsModalFlag) {
            this.filteredNightsModalFlag = true;
            this.filteredModalCount += 1;
            this.filterString += ' nights ';
        }
        else if (nights && nights.length === 0 && this.filteredNightsModalFlag) {
            this.filteredNightsModalFlag = false;
            if (this.filteredModalCount > 0) {
                this.filteredModalCount -= 1;
            }
        }

        if (this.sleepFilter > 2 || this.sleepFilter < 2) {
            this.filterString += ' sleeps ' + this.sleepFilter;
        }

        if (this.selectedPrice < this.maxPrice) {
            this.filterString += ' price ' + this.selectedPrice;
        }

        if (nights.contains(7)) {
            let actualNightsAbove7: number[] = this._actualNights.where(n => n > 7).toArray();
            nights.addRange(actualNightsAbove7);
        }

        let filteredResults: IQueryable<ResortSummary> = resorts
            .where(r =>
                (r.startingFrom <= this.selectedPrice) &&
                (nights.length === 0 || r.resortDurationList.any(rdl => nights.contains(rdl.duration))) &&
                r.resortOccupancyList.any(rol => rol.maxOccupancy >= this.sleepFilter)
            );

        return filteredResults;
    }

    public decrementSleepFilter(): void {
        this.setProperty(() => this.sleepFilter, this.sleepFilter - 1);
        UserActivityLogger.logEvent(SearchEvents.FilterSleepsSelectionChanged, { sleeps: this.sleepFilter }, UserActivityLoggerOptions.AppInsightsOnly);
    }

    public incrementSleepFilter(): void {
        this.setProperty(() => this.sleepFilter, this.sleepFilter + 1);
        UserActivityLogger.logEvent(SearchEvents.FilterSleepsSelectionChanged, { sleeps: this.sleepFilter }, UserActivityLoggerOptions.AppInsightsOnly);
    }

    userSearchFilterModalSelection(value: boolean) {
        UserActivityLogger.logEvent(SearchEvents.userSearchFilterModalSelection, { userchoice: value ? "Applied" : "Cancelled" }, UserActivityLoggerOptions.AppInsightsOnly);

        if (value) {
            this.searchFilterResultModal.closeSearchFilterModal();
            this.getAppliedFilterModalCount();
        }
        else {
            this.reset();
            this.filteredModalCount = 0;
            this.searchFilterResultModal.closeSearchFilterModal();
        }
    }

    public getAppliedFilterModalCount(): number {


        if (this.sleepFilter !== 2 && !this.filteredSleepsModalFlag) {
            this.filteredSleepsModalFlag = true;
            this.filteredModalCount += 1;
        }
        else if (this.sleepFilter === 2 && this.filteredSleepsModalFlag) {
            this.filteredSleepsModalFlag = false;

            if (this.filteredModalCount > 0) {
                this.filteredModalCount -= 1;
            }
        }

        if (this.selectedPrice !== this.maxPrice && !this.filteredPriceSliderModalFlag) {
            this.filteredPriceSliderModalFlag = true;
            this.filteredModalCount += 1;
        }
        else if (this.selectedPrice === this.maxPrice && this.filteredPriceSliderModalFlag) {
            this.filteredPriceSliderModalFlag = false;

            if (this.filteredModalCount > 0) {
                this.filteredModalCount -= 1;
            }
        }

        return this.filteredModalCount;

    }
}

class SearchFilterNight {
    public displayText: string;
    public duration: number;
    public isSelected: boolean;

    constructor(duration: number, displayText: string) {
        this.displayText = displayText;
        this.duration = duration;
    }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/resort-listing/resort-listing.component.ts